import * as React from 'react';
import { useIntl } from 'react-intl';

import HistorySection from '../../../../components/HistorySection';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import { Container, Item } from '../../../../components/Grid';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import { calculateIadlScore } from 'Routes/DiagnosticSurvey/utils';
import InfoPopover from 'Components/InfoPopover';
import { useAppSelector } from 'Store/index';
import { isByInformant } from 'Utility/documentHandling';

const IADLHistory = ({ documents, startEdit, handleMyDelete, view }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  const informants = useAppSelector((state: IState) => state.patient.informants) ?? [];

  return (
    <HistorySection
      headerText={fm('diagnosticSurvey.iadl.title')}
      newButton={
        <DocumentCreationButton
          name="iadl"
          text={'diagnosticSurvey.iadl.newIADL'}
          onClick={startEdit({}, 'iadl')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Container>
            <Item xs={true}>{fm('diagnosticSurvey.iadl.score')}</Item>
          </Container>
        }
        contentFormat={(d: IIADL): React.JSX.Element => {
          const isByInf = isByInformant(d, informants);
          return (
            <Container>
              <Item xs={isByInf ? 2 : true}>
                {calculateIadlScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}
              </Item>
              {isByInf ? <Item xs={true}>{fm('diagnosticSurvey.iadl.byInformant')}</Item> : undefined}
            </Container>
          );
        }}
        makeDate
        makeControls
        historyRowControls={(d: IControlProps) => {
          const isByInf = isByInformant(d, informants);
          return (
            <HistoryRowControls
              document={d}
              startEdit={startEdit}
              view={view}
              enableButtons={isByInf ?? undefined}
              deleteHandler={isByInf ? () => handleMyDelete(d._id, d._type) : undefined}
              hideEditHistory={isByInf}
            />
          );
        }}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IIADL[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
  handleMyDelete: (myDocId: string, docType: string) => Promise<void>;
  view?: IView;
}

export default IADLHistory;
